import { ReactNode, createContext } from 'react'

export type Message = {
    text: ReactNode | string
    level?: 'info' | 'success' | 'warning' | 'error'
    duration?: 'short' | 'medium' | 'long'
    id?: number
}
export type MessageContextProps = {
    messages?: Message[]
    setMessages: (message: Message[]) => void
    clearMessage: (message: Message) => void
}

export const MessageContext = createContext({
    messages: [],
    setMessages: () => {},
    clearMessage: () => {},
} as MessageContextProps)
